import { render, staticRenderFns } from "./DialogEditEmployee.vue?vue&type=template&id=5eccea50&scoped=true"
import script from "./DialogEditEmployee.vue?vue&type=script&lang=js"
export * from "./DialogEditEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eccea50",
  null
  
)

export default component.exports